import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import { host_name } from '../../../../config/Api';
import { getTopMenu } from '../../../actions/Publication.js';

// import './Header.css';



class Commonheader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: {},
            header: [],
            search: '',
        }
    }

    componentDidMount = () => {

        $(document).ready(function ($) {
            var wHeight = window.innerHeight;
            //search bar middle alignment
            $('#mk-fullscreen-searchform').css('top', wHeight / 2);
            //reform search bar
            $(window).resize(function () {
                wHeight = window.innerHeight;
                $('#mk-fullscreen-searchform').css('top', wHeight / 2);
            });
            // Search
            $('#search-button').click(function (e) {
                e.preventDefault();
                $("div.mk-fullscreen-search-overlay").addClass("mk-fullscreen-search-overlay-show");
            });
            $("a.mk-fullscreen-close").click(function (e) {
                e.preventDefault();
                $("div.mk-fullscreen-search-overlay").removeClass("mk-fullscreen-search-overlay-show");
            });
        });

        this.props.getTopMenu().then((res) => {
            this.setState({
                menu: res
            })
        });


    }

    static getDerivedStateFromProps(props, state) {

        return {
            header: props.headers
        }
    }


    handleOnFocuseSubcribe = () => {
        $("#footersubcribe").focus();
    }

    handleSubmit = event => {
        event.preventDefault();
        const { history, match } = this.props;
        const { search } = this.state;
        this.setState({ search: '' });
        history.push(`${match.url}search/${(search)}`);
        $("div.mk-fullscreen-search-overlay").removeClass("mk-fullscreen-search-overlay-show");
    };

    handleChange = event => {
        const { value, name } = event.target;
        this.setState({ [name]: value });
    };



    render() {

        const top_menu = this.props.headers.top_menu;


        const { megamenu_class } = this.state;

        return (
            <Fragment>

                <header>

                    <div className="container">

                        <div className="header-top">

                            <div className="dropdown">

                                <a className="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                                    <i className="fa fa-bars"></i>

                                </a>

                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                    <i className="fa fa-window-close"></i>



                                    {top_menu.length ? <Fragment>

                                        {top_menu.map((row, key) => {
                                            return (
                                                <Fragment key={key}>

                                                    {(row.showing_position == 2 || row.showing_position == 3) &&
                                                        <Link to={`/${row.slug}`} className="dropdown-item">{row.category_name}</Link>
                                                    }
                                                </Fragment>

                                            )
                                        })}

                                    </Fragment> : ''}
                                </div>

                            </div>



                            <div className="logo">

                                <a href={host_name} target="_blank"><img src={require('../../../img/logo.svg').default} /></a>

                            </div>

                            <h1><Link to="/">Publications</Link></h1>

                            <div className="search-box">

                                <div className="searchbar">

                                    <div className="overlay">

                                        <a className="mk-search-trigger mk-fullscreen-trigger" href="" id="search-button-listener">
                                            <div id="search-button"><i className="fa fa-search"></i></div>
                                        </a>

                                        <div className="mk-fullscreen-search-overlay" id="mk-search-overlay">

                                            <a href="" className="mk-fullscreen-close" id="mk-fullscreen-close-button"><i className="fa fa-times"></i></a>
                                            <div id="mk-fullscreen-search-wrapper">

                                                <form method="get" id="mk-fullscreen-searchform" onSubmit={this.handleSubmit}>

                                                    <input type="text" name='search' value={this.state.search}
                                                        required onChange={this.handleChange} placeholder="Search..." id="mk-fullscreen-search-input" />
                                                    <i className="fa fa-search fullscreen-search-icon">
                                                        <input onClick={this.handleSubmit} type="submit" value="" /></i>

                                                </form>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="sticky-header">

                        <div className="container">

                            <div className="main-menu">

                                <div id="main-nav" className="stellarnav dark desktop">

                                    <nav>

                                        <ul>
                                            <li >
                                                <Link to={`/`}>Home</Link>
                                            </li>
                                            {top_menu.length ? <Fragment>

                                                {top_menu.map((row, key) => {
                                                    return (
                                                        <Fragment key={key}>

                                                            {(row.showing_position == 1 || row.showing_position == 3) && <li >
                                                                <Link to={`/${row.slug}`}>{row.category_name}</Link>
                                                            </li>}
                                                        </Fragment>

                                                    )
                                                })}

                                            </Fragment> : ''}

                                        </ul>

                                    </nav>

                                </div>

                            </div>

                            <button className="btn btn-danger" onClick={() => this.handleOnFocuseSubcribe()}>Subscribe</button>
                        </div>

                    </div>

                </header>


            </Fragment>

        );
    }
}

const mapStateToProps = (state) => ({
    headers: state.pubheader,
    setting: state.utils.setting,
})

const mapDispatchToProps = (dispatch) => ({
    getTopMenu: (requestData) => dispatch(getTopMenu(requestData))
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Commonheader));

